import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CreateCardAccountStackRoutes, CreateCardAccountStackScreenProps } from './type';
import { CreateCardAccountWebIndividualScreen } from './CreateCardAccountWebIndividual.screen';
import { CreateCardAccountNativeIndividualScreen } from './CreateCardAccountNativeIndividual.screen';

export const CreateCardAccountIndividual: React.FC<CreateCardAccountStackScreenProps<CreateCardAccountStackRoutes.Individual>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, onData, func, onReturnData, refresh, onChangeView, onBackData } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <CreateCardAccountNativeIndividualScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        onData={onData}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
        onBackData={onBackData}
      />
    );
  }

  return (
    <CreateCardAccountWebIndividualScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      onData={onData}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
      onBackData={onBackData}
    />
  );
};
